import React from 'react';
import Field from "../../components/Form/Field";

type Props = {
    id: string
    name: string
    value: string | number
    label: string
    description?: string
    readonly?: boolean
}

function Checkbox({id, name, value, label, description, readonly}: Props) {
    return (
        <div className="relative flex items-start">
            <div className="flex items-center h-5">
                <Field
                    type="checkbox"
                    id={id}
                    name={name}
                    value={value}
                    disabled={readonly}
                    aria-describedby={description? `${id}-description` : undefined}
                />
            </div>
            <div className="ml-3 text-sm">
                <label htmlFor={id} className="font-medium text-gray-700">
                    {label}
                </label>

                {description &&
                    <p id={`${id}-description`} className="text-gray-500">
                        {description}
                    </p>
                }
            </div>
        </div>
    );
}

export default Checkbox;